import {Modal} from 'react-bootstrap';
import styles from './successModal.module.scss';
type TDangerModalProps = {
  show: boolean;
  setShow: (e: boolean) => void;
  title: string;
  description?: string;
  onClick?: () => void;
};
const SuccessModal = ({
  show,
  setShow,
  title,
  onClick,
  description,
}: TDangerModalProps) => {
  return (
    <>
      <Modal centered show={show} onHide={() => setShow(false)} size="sm">
        <div className={styles['success-modal']}>
          <div className={styles['success-modal__icon']}>
            <i className="icon-success-field"></i>
          </div>
          <div className="p-3 py-5 mt-4 text-center">
            <b className="color-primary">{title}</b>
            <div className="mt-2">
              <small className="color-gray-1">{description}</small>
            </div>
          </div>

          <div className="d-flex mb-3">
            <button
              className="w-100 btn btn-success border-0 bg-color-primary color-white mx-3 py-3"
              onClick={onClick}
            >
              باشه
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default SuccessModal;
